export const syncCalendar = {
  title: "Kalender synchronisieren",
  description:
    "Ist Ihre Unterkunft auf mehreren Portalen gelistet? Durch die Synchronisierung der Kalender sehen Sie Ihre Buchungen und Verfügbarkeiten aller Kanäle auf einen Blick. Sie können Kalender im iCal-Format importieren und exportieren und Ihre Liste der geplanten Check-ins aktuell halten.",
  accommodation: "Unterkunft",
  sync: "Synchronisieren",
  addCalendar: "Neuen Kalender hinzufügen",
  confirmSync: {
    message: "Möchten Sie die Kalender aktualisieren?",
  },
  syncSuccess: {
    message: "Kalender erfolgreich synchronisiert",
    title: "Synchronisierung erfolgreich",
  },
  calendarName: "Kalendername",
  modal: {
    header: "Kalender hinzufügen",
    nameLabel: "Geben Sie den Kalendernamen ein",
    linkLabel: "Kopieren Sie Ihren Kalenderlink hier hinein",
    linkPlaceholder: "iCal-Link",
    cancel: "Abbrechen",
    save: "Speichern und synchronisieren",
  },
  saveSuccess: {
    message: "Erfolg",
    title: "Kalender erfolgreich gespeichert",
  },
  errors: {
    validationTitle: "Prüfung fehlgeschlagen",
    saveErrorTitle: "Fehler beim Speichern des Kalenders",
    unexpected: "Ein unerwarteter Fehler ist aufgetreten.",
  },
  list: {
    updated: "Aktualisiert",
    status: "Status",
    synced: "Synchronisiert",
    delete: "Löschen",
    empty: "Keine Kalender synchronisiert",
  },
  deleteConfirm: {
    title: "Möchten Sie den Kalender löschen?",
    content:
      'Beim Löschen des Kalenders werden auch die im Menü "Geplante Check-ins (Buchungen)" synchronisierten Buchungen gelöscht',
  },
  deleteSuccess: {
    message: "Kalender erfolgreich gelöscht",
    title: "Gelöscht",
  },
  deleteError: {
    message: "Fehler beim Löschen des Kalenders",
    title: "Fehler",
  },
};
